import { Grid, makeStyles, Typography } from "@material-ui/core";

import { COLORS } from "../../theme/colors";
import { ColorIndicator } from "../colorIndicator";
import { MAP_ICON_COLORS } from "../../pages/dashboard/constants";

const useStyles = makeStyles((theme) => ({
  legendsContainer: {
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4),
    position: "relative",
    bottom: theme.spacing(5),
    backgroundColor: COLORS.white,
    opacity: 0.85,
    borderRadius: 9,
    width: "fit-content",
  },
  legend: {
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1.5),
  },
}));

export const MapLegends = ({ legends }) => {
  const classes = useStyles();

  return (
    <Grid className={classes.legendsContainer} container alignItems="center">
      {legends.map((legend, index) => (
        <Grid key={index} item>
          <Grid className={classes.legend} container alignItems="center">
            <ColorIndicator color={MAP_ICON_COLORS[legend.status] || COLORS.white} />
            <Typography>{legend.text}</Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};
